import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import {
  grantFitTierClass,
  grantFitTierDotClass,
  grantFitTierLabel,
  type GrantFitTier,
} from "@/components/grant_suite/grantFitDisplay";

type GrantFitBadgeProps = {
  tier: GrantFitTier;
  className?: string;
};

export function GrantFitBadge({ tier, className }: GrantFitBadgeProps) {
  return (
    <Badge
      variant="secondary"
      className={cn("gap-1.5 text-xs font-medium", grantFitTierClass(tier), className)}
    >
      <span
        className={cn("h-1.5 w-1.5 shrink-0 rounded-full", grantFitTierDotClass(tier))}
        aria-hidden
      />
      {grantFitTierLabel(tier)}
    </Badge>
  );
}
